import React from 'react'
import NotFoundGrid from './Grid'

// Component
const NotFoundContainer = () => {
  return <NotFoundGrid />
}

export default NotFoundContainer
